import {
    MobileHistoryTransactionClockIconContainerStyled
} from "./styled/MobileHistoryTransactionStyled";
import { BinIcon } from "../../../../../components/icon/Icon";
import amountFormat from "../../../../../utils/amountFormat";
import {
    STATE_TX,
    TRANSACTION_SIDES
} from "../../../../../modules/Account/components/TransactionHistory/transactionHistoryConstants";
import classNames from "classnames";
import { useLangContext } from "../../../../../providers/LangProvider/LangProviderContext";
import { useCallback } from "react";
import { connect } from "react-redux";
import { setAccountSelectedHistoryInfoAction } from "../../../../../modules/Account/accountActions";
import { openMobileSliderPageAction } from "../../../../mobileAppActions";
import { MOBILE_SLIDER_PAGES_IDS } from "../../../MobileSliderPages/mobileSliderPagesConstants";
import { MOBILE_HISTORY_INFO_TYPES } from "../../mobileHistoryConstants";
import MobileHistoryTransactionIcon from "../MobileHistoryTransactionIcon";
import {
    MobileHistoryRowStyled,
    MobileHistoryRowIconContainerStyled,
    MobileHistoryRowAmountStyled
} from "../../styled/MobileHistoryRowStyled";

function MobileHistoryTransactionRow(props) {
    const {item, openMobileSliderPage, setAccountSelectedHistoryInfo} = props;
    const {getLangPath} = useLangContext();

    const amount = item.side === TRANSACTION_SIDES.UP ? +item.amount : -item.amount;

    const handleRowClick = useCallback(() => {
        setAccountSelectedHistoryInfo({info: item, type: MOBILE_HISTORY_INFO_TYPES.TRANSACTION});
        openMobileSliderPage({
            name: MOBILE_SLIDER_PAGES_IDS.HISTORY_INFO,
            type: MOBILE_HISTORY_INFO_TYPES.TRANSACTION,
            id: item.uuid,
        });
    }, [item, openMobileSliderPage, setAccountSelectedHistoryInfo]);

    return <MobileHistoryRowStyled onClick={handleRowClick}>
        <MobileHistoryRowIconContainerStyled>
            <MobileHistoryTransactionIcon item={item}/>
            {
                item.state === STATE_TX.PROCESSING && (
                    <MobileHistoryTransactionClockIconContainerStyled>
                        <BinIcon name="IcClockBlackCircle"/>
                    </MobileHistoryTransactionClockIconContainerStyled>
                )
            }
        </MobileHistoryRowIconContainerStyled>
        <div className="flex-1 overflow-hidden">
            <div className="f16 text-truncate">
                {getLangPath(`lite_version.history.transaction.title.${item.type}`, {payment_name: item.payment_name})}
            </div>
            <div className="color-white-60">{item.payment_name}</div>
        </div>
        <div className="ms-2 text-right">
            <MobileHistoryRowAmountStyled className={classNames({
                'negative': item.amount <= 0,
                'positive': item.amount > 0,
                'secondary': item.state === STATE_TX.PROCESSING,
            })}>
                {amountFormat(amount, 2, '$')}
            </MobileHistoryRowAmountStyled>
            <div className="color-white-60">{item.formattedDate}</div>
        </div>
    </MobileHistoryRowStyled>
}

const mapDispatchToProps = (dispatch) => ({
    openMobileSliderPage: payload => dispatch(openMobileSliderPageAction(payload)),
    setAccountSelectedHistoryInfo: payload => dispatch(setAccountSelectedHistoryInfoAction(payload)),
});

export default connect(null, mapDispatchToProps)(MobileHistoryTransactionRow);
